// Fix the positioning of bottom floating ad based on sharebar presence/absence
(function($){
    var tries = 0;
    var mbf = $(".mobileweb_bottom_floating");
    var ic = $(".inner-container");
    mbf.css("border-top", "none");
    var intvl = setInterval(function(){
        var sbb = $(".shareBarBottom");
        mbf.css("margin-bottom", sbb.height() + "px");
        ic.css("padding-bottom", (mbf.height() + sbb.height()) + "px");
        if (tries === 50)
            clearInterval(intvl);
        tries++;
    }, 500);
})(jQuery);

(function () {
    'use strict';

    // TODO: Isn't this too heavy? Can't we simplify it.
    var retries = 500;
    var clIntvl = setInterval(function(){
        if ( $("#closeDiv").length || retries === 0 ) {
            $("#closeDiv").bind("click", function(){
                $("body").removeClass("bgImg");
                return;
            });
            clearInterval(clIntvl);
        }
        retries--;
    }, 10);

})();